import React, { useEffect, useState } from "react";
import { Globe, Check, ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";

export const LANGS = [
  { code: "es", label: "Español", short: "ES" },
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "pt", label: "Português", short: "PT" },
  { code: "de", label: "Deutsch", short: "DE" },
  { code: "it", label: "Italiano", short: "IT" },
  { code: "ru", label: "Русский", short: "RU" },
  { code: "zh-CN", label: "中文", short: "ZH" },
];

const getCurrent = () => {
  const m = document.cookie.match(/googtrans=\/[^/]+\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "es";
};

const setCookie = (val) => {
  const host = window.location.hostname;
  const exp = val ? "" : "; expires=Thu, 01 Jan 1970 00:00:00 GMT";
  const v = val ? `/es/${val}` : "";
  document.cookie = `googtrans=${v}; path=/${exp}`;
  document.cookie = `googtrans=${v}; path=/; domain=${host}${exp}`;
  document.cookie = `googtrans=${v}; path=/; domain=.${host.split(".").slice(-2).join(".")}${exp}`;
};

// Loads the Google Translate engine once (hidden widget)
export function GoogleTranslateLoader() {
  useEffect(() => {
    if (document.getElementById("gt-script")) return;
    window.googleTranslateElementInit = () => {
      // eslint-disable-next-line no-new
      new window.google.translate.TranslateElement(
        { pageLanguage: "es", includedLanguages: LANGS.map((l) => l.code).join(","), autoDisplay: false },
        "google_translate_element"
      );
    };
    const s = document.createElement("script");
    s.id = "gt-script";
    s.src = "https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    s.async = true;
    document.body.appendChild(s);
  }, []);
  return <div id="google_translate_element" aria-hidden="true" />;
}

export default function LanguageSelector() {
  const [current, setCurrent] = useState("es");
  useEffect(() => { setCurrent(getCurrent()); }, []);
  const cur = LANGS.find((l) => l.code === current) || LANGS[0];

  const change = (code) => {
    if (code === current) return;
    if (code === "es") { setCookie(null); window.location.reload(); return; }
    setCookie(code);
    const combo = document.querySelector(".goog-te-combo");
    if (combo) {
      combo.value = code;
      combo.dispatchEvent(new Event("change"));
      setCurrent(code);
    } else {
      window.location.reload();
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-selector-btn" translate="no"
          className="notranslate flex items-center gap-1.5 rounded-full bg-gray-50 hover:bg-gray-100 px-3 py-1.5 text-xs transition-colors outline-none">
          <Globe className="w-3.5 h-3.5 brand-text" />
          <span className="font-semibold brand-text">{cur.short}</span>
          <span className="text-gray-500 hidden sm:inline">{cur.label}</span>
          <ChevronDown className="w-3 h-3 text-gray-400" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="notranslate w-48" translate="no">
        <DropdownMenuLabel className="text-xs text-gray-500 font-normal">Traducido por Google</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {LANGS.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => change(l.code)} data-testid={`lang-option-${l.code}`} className="flex justify-between cursor-pointer">
            <span>{l.label}</span>{l.code === current && <Check className="w-4 h-4 brand-text" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
